import { Preferences } from '@capacitor/preferences';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

export const useCapacitorStorage = () => {
  const setValue = async (key: string, value?: string | undefined, secure = false) => {
    if (value === undefined) {
      await Preferences.remove({ key });
      await SecureStoragePlugin.remove({ key }).catch(reason => {
        console.warn(`Failed to remove secure storage key: ${key}`, reason);
      });
      return;
    }

    if (secure) {
      await SecureStoragePlugin.set({ key, value });
      return;
    }

    await Preferences.set({
      key,
      value
    });
  };

  const getValue = async (key: string) => {
    let { value } = await Preferences.get({ key });

    if (value === null || value === '') {
      value = await SecureStoragePlugin.get({ key })
        .then(secValue => {
          return secValue.value;
        })
        .catch(reason => {
          console.warn(`Failed to retrieve secure storage key: ${key}`, reason);
          return null;
        });
    }

    return value;
  };

  const resetStore = async () => {
    await Preferences.clear();
    await SecureStoragePlugin.clear();
  };

  return {
    setValue,
    getValue,
    resetStore
  };
};
